import {createFileRoute} from '@tanstack/react-router';
import SignInPage from '@features/auth/signin/page';
import {z} from 'zod';

export const Route = createFileRoute('/auth/signin')({
  component: SignInPage,
  validateSearch(search: object) {
    return z
      .object({
        email: z.string().optional(),
      })
      .parse(search);
  },
});
